import { Box } from '@mui/material'

const SellRail = () => {
  return <Box>Sell Rail</Box>
}

export default SellRail
